import React, { useContext } from "react";

import { PropertyListingContext, SearchContext } from "components/store/source";

import Collections from "./Collections";

function CollectionsContainer({ ...props }) {
  const { collections, isCollectionLoading } = useContext(
    PropertyListingContext,
  );
  const {
    criteria: { checkIn, checkOut },
  } = useContext(SearchContext);

  return (
    <Collections
      collections={collections}
      isCollectionLoading={isCollectionLoading}
      checkIn={checkIn}
      checkOut={checkOut}
      {...props}
    />
  );
}

export default CollectionsContainer;
